'use client'

import { useState } from 'react'
import type { MouseEvent } from 'react'
import { useStore } from '@/store'
import { usePathname, useSearchParams } from 'next/navigation'
import { InfoAlert } from '@/General/InfoAlert'
import { TextLink } from '@/General/TextLink'
import { CommunityRulesAlert } from '../CommunityRules'
import { QuestionForm } from '../QuestionForm'
import { LoginModal } from '@/MainLayout/Header/TopMenu/LoginModal'

interface AuthCheckProps {
  productId: number
  productSlug: string
  productName: string
}

export function AuthCheck({ productId, productSlug, productName }: AuthCheckProps) {
  const user = useStore(state => state.user)
  const [isLoginOpen, setIsLoginOpen] = useState(false)
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const search = searchParams.toString()
  const redirectPath = search ? `${pathname}?${search}` : pathname
  const signupUrl = `/account/signup${
    redirectPath ? `?redirect=${encodeURIComponent(redirectPath)}` : ''
  }`
  const handleLoginClick = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()
    setIsLoginOpen(true)
  }

  if (!user) {
    return (
      <>
        <LoginModal
          isLoginOpen={isLoginOpen}
          setIsLoginOpen={setIsLoginOpen}
          redirectTo={redirectPath}
        />
        <InfoAlert
          variant="warning"
          title="Please log in to ask a question"
          className="mt-4"
        >
          You need to be logged in to ask the community a question.{' '}
          <TextLink href={redirectPath} onClick={handleLoginClick}>
            Click here to log in
          </TextLink>{' '}
          or <TextLink href={signupUrl}>create an account</TextLink> if you
          don't have one yet.
        </InfoAlert>
      </>
    )
  }

  return (
    <>
      <CommunityRulesAlert />
      <QuestionForm 
        productId={productId}
        productSlug={productSlug}
        productName={productName}
      />
    </>
  )
}
